import PropTypes from 'prop-types';
import React from 'react';

// This is based on mountain-bike/js/dynamic_textarea.coffee
export default class DynamicTextArea extends React.Component {
    static defaultProps = {
        onChange: function() {},
        defaultHeight: 24,
    };

    static propTypes = {
        defaultHeight: PropTypes.number,
        forwardedRef: PropTypes.func,
        onChange: PropTypes.func,
        value: PropTypes.string,
    };

    textAreaRef = el => {
        const { forwardedRef } = this.props;
        this.textArea = el;
        if (forwardedRef) {
            forwardedRef(el);
        }
    };

    componentDidMount() {
        this.updateSize();
    }

    // Called after all other render()s.
    componentDidUpdate() {
        this.updateSize();
    }

    onChange = event => {
        this.props.onChange(event);

        // If this is NOT a Controlled Input then updateSize() needs to be
        // called.  If it is a Controlled Input then updateSize() will happen
        // when new props arrive (componentDidUpdate)
        if (!this.props.value) {
            this.updateSize();
        }
    };

    updateSize = () => {
        const { textArea } = this;

        textArea.style.height = 0;
        textArea.style.height =
            textArea.scrollHeight + this.props.defaultHeight + 'px';

        textArea.style.overflow = 'hidden';
        if (textArea.scrollHeight > textArea.offsetHeight) {
            textArea.style.overflow = 'scroll';
        }
    };

    render() {
        const { onChange, defaultHeight, forwardedRef, ...props } = this.props;
        props.onChange = this.onChange;
        props.className = 'dynamic-textarea ' + (props.className || '');

        return <textarea {...props} ref={this.textAreaRef} />;
    }
}



// WEBPACK FOOTER //
// ./src/components/dynamic_text_area.jsx